var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-box-bg"},[_c('div',{staticClass:"error-box"},[_c('img',{attrs:{"src":_vm.img,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.$t('home.loginOut')))]),_c('div',{staticClass:"refresh-btn",on:{"click":_vm.handleRefresh}},[_vm._v(_vm._s(_vm.$t('home.refresh')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }